import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import {date_format, datetime_format} from "../Common/DateFormat";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function TransactionCategoryList(props) {
    const { t } = useTranslation();
    const transactionType = props.match.params.type.toLowerCase();
    const transactionTypeTitle = transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
    const [transactionCategorys, setTransactionCategorys] = useState([]);
    const [transactionCategory, setTransactionCategory] = useState(-1);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentTransactionCategory = (transactionCategory) => {
        setTransactionCategory(transactionCategory);
        setShow(true);

    };

    const handleClose = () => setShow(false);

    const deleteTransactionCategory = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(
            API_URL + 'transaction-category/' + transactionCategory.id + '/delete'
        ).then((response) => {
            if (response.data?.status === true) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        });
    }

    useEffect(() => {

        axios.get(API_URL + 'transaction-category/'+transactionType).then((response) => {
            if ($.fn.DataTable.isDataTable("#transaction_category_table")) {
                $("#transaction_category_table").DataTable().destroy();
            }

            if (response.data?.status === true) {
                const transactionCategoryRows = Array.isArray(response.data?.data) ? response.data.data : [];
                setTransactionCategorys(transactionCategoryRows);

                if (transactionCategoryRows.length > 0) {
                    setTimeout(() => {
                        if ($.fn.DataTable.isDataTable("#transaction_category_table")) {
                            $("#transaction_category_table").DataTable().destroy();
                        }
                        $("#transaction_category_table").DataTable();
                    }, 0);
                }
            } else {
                setTransactionCategorys([]);
                alertify.error(response.data?.message || "Something went wrong. Try again!");
                return null;
            }
        }).catch((error) => {
            setTransactionCategorys([]);
            alertify.error(error.response?.data?.message || "Something went wrong. Try again!");
        });

        return () => {
            if ($.fn.DataTable.isDataTable("#transaction_category_table")) {
                $("#transaction_category_table").DataTable().destroy();
            }
        }
    }, [transactionType]);


    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={transactionTypeTitle+' Category List'}>
                            <CardHeaderToolbar>
                                <Link to={`/transaction-category/create/${transactionType}`} className="btn btn-primary btn-sm mx-3">
                                    Create {transactionTypeTitle} Category
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow:'auto'}}>

                            <table id="transaction_category_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Notes")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {transactionCategorys.length > 0 ? (
                                    transactionCategorys.map((transactionCategory, index) => (
                                        <tr key={transactionCategory.id}>
                                            <td>{index + 1}</td>
                                            <td>{transactionCategory.name}</td>
                                            <td>{transactionCategory.notes}</td>
                                            <td>
                                                <Link to={`/transaction-category/edit/${transactionCategory.id}/${transactionType}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                          <SVG
                                                              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                          />
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentTransactionCategory(transactionCategory)}
                                                    key={transactionCategory.id}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm">
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                      <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>

                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>{t("No Transaction Category")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Transaction Category")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="primary" onClick={deleteTransactionCategory} disabled={disabled}>
                        {t("Confirm")}
                        <span
                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
